"use client";
import { GlobalContext } from "@/context";
import axios from "axios";
import { useContext, useState } from "react";
import { useRouter } from "next/navigation";

const PaymentMethod = () => {
  const router = useRouter();
  const { panierData, setPanierData, userData, setPanierStatus } =
    useContext(GlobalContext);
  const [paymentMéthode, setPaymentMéthode] = useState();
  const [paymentStatus, setPaymentStatus] = useState("");
  const [checkPaymentIsDone, setCheckPaymentIsDone] = useState(false);
  const [orderStatus, setOrderStatus] = useState("");

  // This function is responsible for clearing the panier data, displaying a message, and navigating to the home page after 3 seconds.
  const OrderCompleted = () => {
    setOrderStatus("Votre commande a été envoyée avec succès.");
    localStorage.removeItem("panier");
    sessionStorage.removeItem("paymentRef");
    setPanierData([]);
    setTimeout(() => {
      router.push("/");
    }, 3000);
    setTimeout(() => {
      setPanierStatus(1);
    }, 4000);
  };

  const CreateOrder = async (payment, paymentRef) => {
    if (payment) {
      const data = await axios
        .post(`/order/post`, {
          owner: userData?.id || null,
          PaymentMethod: paymentMéthode || false,
          PanierData: panierData,
          AdrressId: JSON.parse(localStorage.getItem("adressId")),
        })
        .then((res) => {
          OrderCompleted();
        })
        .catch((err) =>
          setOrderStatus("Une erreur est survenue. Veuillez réessayer.")
        );
    } else if (payment == false) {
      const data = await axios
        .post(`/order/post`, {
          owner: userData?.id || null,
          PaymentMethod: paymentMéthode || false,
          PanierData: panierData,
          AdrressId: JSON.parse(localStorage.getItem("adressId")),
          paymentRef: paymentRef,
        })
        .then((res) => res.data)
        .then((res) => {
          if (res?.payment?.status == "completed") {
            OrderCompleted();
          }
        })
        .catch((err) =>
          setOrderStatus("Une erreur est survenue. Veuillez réessayer.")
        );
    }
  };

  const paymentEnLigne = async () => {
      const totalWithoutDelivery = panierData?.reduce((accumulator, currentValue) => {
        const finalPrice = currentValue.promo
            ? currentValue.price -
              (currentValue.price / 100) * currentValue.promo
            : currentValue.price;

        return accumulator + finalPrice * currentValue.qt;
    }, 0);
    const total = totalWithoutDelivery + (totalWithoutDelivery >= 100 ? 0 : 9);
    const data = await axios
      .post(
        `${process.env.NEXT_PUBLIC_KONNECT}/payments/init-payment`,
        {
          receiverWalletId: process.env.NEXT_PUBLIC_KONNECT_Rceiver_Wallet_Id,
          token: "TND",
        amount: Math.round(total * 1000)
            ,
        },
        {
          headers: {
            "x-api-key": process.env.NEXT_PUBLIC_KONNECT_API_KEY,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => res.data)
      .then((res) => {
        setCheckPaymentIsDone(true);
        sessionStorage.setItem("paymentRef", res.paymentRef);
        window.open(res.payUrl, "_blank");
      })
      .catch((err) => {
        setPaymentStatus(
          "Un problème est survenu. Veuillez réessayer dans quelques instants."
        );
      });
  };

  const ConfirmPayment = async () => {
    const data = await axios
      .get(
        `${process.env.NEXT_PUBLIC_KONNECT}/payments/${sessionStorage.getItem(
          "paymentRef"
        )}`,
        {
          headers: {
            "x-api-key": "6756aecc7b0aa74ffe31a17a:xCw7cn5X7Ld4hL9aC3",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => res.data)
      .then((res) => {
        setPaymentStatus(
          res?.payment?.status == "pending"
            ? "Votre paiement est en attente."
            : res?.payment?.status == "completed"
            ? "Le paiement a été effectué avec succès. Merci pour votre achat !"
            : "Un problème est survenu. Veuillez réessayer dans quelques instants."
        );
        if (res?.payment?.status == "completed") {
          CreateOrder(false, sessionStorage.getItem("paymentRef"));
        }
      })

      .catch((err) => setPaymentStatus("error occur"));
  };

  return (
    <div className="w-[80%] mx-auto flex flex-col lg:flex-col gap-4 ">
      <h2 className="text-[24px] lg:text-[40px] font-semibold">
        Méthode de Paiement
      </h2>
      <div className="flex gap-2 items-center">
        <input
          type="radio"
          id="àLaLivraison"
          name="paymentMethod"
          value="àLaLivraison"
          className="w-4 h-4"
          onChange={() => {
            setPaymentMéthode(true);
          }}
        />
        <label
          for="àLaLivraison"
          className="text-[18px] lg:text-[24px] font-normal"
        >
          Paiement à la Livraison
        </label>
      </div>
      <div className="flex gap-2 items-center">
        <input
          type="radio"
          id="enLigne"
          name="paymentMethod"
          value="enLigne"
          className="w-4 h-4 bg-[#CC0001]"
          onChange={() => {
            setPaymentMéthode(false);
          }}
        />
        <label for="enLigne" className="text-[18px] lg:text-[24px] font-normal">
          Paiement en Ligne
        </label>
      </div>
      <div className="flex justify-end">
        {paymentMéthode === true ? (
          <button
            className="text-[#FFFFFF] uppercase bg-[#CC0001] text-base px-4 w-fit self-end rounded-[19px] py-3"
            onClick={() => {
              CreateOrder(true);
            }}
          >
            Passer la Commande
          </button>
        ) : paymentMéthode === false ? (
          <div className="fle flex-col">
            <div className="flex flex-col md:flex-row gap-2">
              <button
                className="text-[#FFFFFF] uppercase bg-[#CC0001] text-base px-4 w-fit self-end rounded-[19px] py-3 mx-auto"
                onClick={() => {
                  paymentEnLigne();
                }}
              >
                Paiement
              </button>
              {checkPaymentIsDone ? (
                <button
                  className="text-[#FFFFFF] uppercase bg-[#CC0001] text-base px-4 w-fit self-end rounded-[19px] py-3 mx-auto"
                  onClick={() => {
                    ConfirmPayment();
                  }}
                >
                  Confirmer le Paiement
                </button>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      <h3 className="text-[16px] md:text-[20px] text-center">
        {paymentStatus}
      </h3>
      {orderStatus ? (
        <div className="flex gap-2 justify-center">
          <h3 className="text-[16px] md:text-[20px] text-center">
            {orderStatus}
          </h3>
          <img src="/orderDone.jpg" width="20" height="20"></img>
        </div>
      ) : null}
    </div>
  );
};

export default PaymentMethod;
